import { useAppSelector } from '../../../store';

export const useGetProjectsData = () => {
    const { projects } = useAppSelector((state) => state.tasksInformationReducer);

    return { projects };
};
